import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const InspectionFormDetail = lazyLoader(
  () =>
    import(
      "Containers/Inspections/InspectionsFormsDashboard/InspectionFormDetail/InspectionFormDetail"
    )
);

export const InspectionFormDetailPage = () => {
  return (
    <Layout>
      <InspectionFormDetail />
    </Layout>
  );
};
